import type { ReactNode } from 'react';
import { Route, Routes, Navigate } from 'react-router';
import { useIsEmberRoute } from '@repo/poly-hooks/hooks/use-is-ember-route.tsx';
import { browserHistory, ReactRouter } from './history';
import { NotFound } from './routes/not-found';
import { AppLayout } from './routes/app-layout';
import { BusinessActivity } from './routes/business-activity';
import { OwnerInfoRoute } from './routes/registration/owner-info/owner-info';
import { KycRoute, KycGuard, KycLayout } from './routes/registration/kyc';

function CheckIfEmberHasRoute(): React.ReactNode {
  const isEmberRoute = useIsEmberRoute();
  return isEmberRoute() ? null : <Navigate replace to="/404" />;
}

export function Router({ path }: { path: string }): ReactNode {
  return (
    // @ts-expect-error react-router's History type has extra methods
    <ReactRouter history={browserHistory} key={path}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="registrations/:registration_id">
            <Route element={<OwnerInfoRoute />} path="owner-info" />
            <Route element={<KycLayout />} path="new-kyc/*">
              <Route element={<KycGuard />}>
                <Route element={<KycRoute />} index />
              </Route>
            </Route>
          </Route>
          <Route element={<NotFound />} path="/404" />
          <Route
            element={<BusinessActivity />}
            path="/registrations/:registrationId/business-activity"
          />
          <Route element={<CheckIfEmberHasRoute />} path="*" />
        </Route>
      </Routes>
    </ReactRouter>
  );
}
